import { useState } from 'react';
import { NavIconButton } from '../NavIconButton/NavIconButton';
import { NavigationMenu } from '../NavigationMenu/NavigationMenu';
import { Icon, IconName } from '@hills-design-system/components';
import { useTranslation } from '../../hooks/useTranslation';
import { useMissedReportsCount } from '../../hooks/useMissedReportsCount';
import { TranslationKeyEnum } from '../../types/constants';
import { Link } from 'react-router-dom';
import { getAssetUrl } from '../../utils/assetUrl';

interface NavbarProps {
  shelterName?: string;
}

export const Navbar = ({ shelterName }: NavbarProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { t } = useTranslation();
  const { total: missedReportsCount } = useMissedReportsCount();

  return (
    <>
      <nav className="w-full bg-white py-11 flex items-center justify-between relative">
        <div className="flex items-center">
          <NavIconButton
            icon={<Icon icon={IconName.Menu} size={24} />}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label={t(TranslationKeyEnum.MenuButton)}
          />
        </div>

        <div className="absolute left-1/2 transform -translate-x-1/2">
          <Link to="/">
            <img
              src={getAssetUrl('fsl-logo.svg')}
              alt={t(TranslationKeyEnum.FoodShelterLoveLogo)}
              className="h-16"
            />
          </Link>
        </div>

        <div className="flex justify-end items-center w-[260px] h-12 rounded-200">
          <span className="text-right font-semibold text-base text-black/90">
            {shelterName ?? t(TranslationKeyEnum.Loading)}
          </span>
        </div>
      </nav>

      <NavigationMenu
        isOpen={isMenuOpen}
        onClose={() => setIsMenuOpen(false)}
        missedReportsCount={missedReportsCount}
      />
    </>
  );
};
